import { render, staticRenderFns } from "./infoGetLoan.vue?vue&type=template&id=1dfcdb78&scoped=true"
import script from "./infoGetLoan.vue?vue&type=script&lang=js"
export * from "./infoGetLoan.vue?vue&type=script&lang=js"
import style0 from "./infoGetLoan.vue?vue&type=style&index=0&id=1dfcdb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfcdb78",
  null
  
)

export default component.exports